import React, { FC } from 'react';
import { Container, Form } from 'react-bootstrap';
import { ThemeResponseDto } from '../../../store/landscapeAPI/theme/dto/response/theme-response.dto';
import { Button, RadioButton } from '../../atoms';
import styles from './ReportingDetailsThemesForm.module.css';
import { ImageUploader } from '../../molecules';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';

interface ReportingDetailsThemesFormProps {
  data: ThemeResponseDto;
  callbackFn: (theme: ThemeResponseDto) => void;
  handleOnChange: (theme: ThemeResponseDto) => void;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
}

const ReportingDetailsThemesForm: FC<ReportingDetailsThemesFormProps> = ({
  data,
  callbackFn,
  handleOnChange,
  handleImageOnChange,
}) => {
  const handleSubmit: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    callbackFn(data);
  };
  return (
    <Container className={styles.form}>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            value={data.name}
            onChange={(e) =>
              handleOnChange({
                ...data,
                name: e.target.value,
              })
            }
          ></Form.Control>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Description</Form.Label>
          <Form.Control
            type="text"
            value={data.description ?? ''}
            onChange={(e) =>
              handleOnChange({
                ...data,
                description: e.target.value,
              })
            }
          ></Form.Control>
        </Form.Group>
        <Form.Group className="mb-3">
          <ImageUploader
            setImage={(e) => {
              handleOnChange({ ...data, icon: e });
            }}
            imageSrc={data.icon ?? undefined}
            id={data.id}
            setImageMeta={(imageMeta) => handleImageOnChange(imageMeta)}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Is Published</Form.Label>
          <br />
          <RadioButton
            defaultChecked={data.published}
            onChange={(checked) =>
              handleOnChange({
                ...data,
                published: checked,
              })
            }
          />
        </Form.Group>
        <Button variant={'dark'} onClick={handleSubmit}>
          Save
        </Button>
      </Form>
    </Container>
  );
};

export default ReportingDetailsThemesForm;
